module.exports = __webpack_public_path__ + "media/Audio19_c.5a45d4bc.wav";